module.exports = __webpack_public_path__ + "static/media/affiliate-banner-en.b7bf722b.png";